<template>
  <div class="line-chart" :style="{width: config.chartWidth+'px',height:config.chartHeight+'px'}">
    <div class="line-chart-wrapper">
      <img v-if="borderImgUrl" class="line-chart-border" :src="borderImgUrl" alt=""
           :style="{
             display:'inline-block',
             width:'100%',
             height: '100%'
           }">
      <div class="line-chart-title" :style="{
        width:'100%',
        textAlign: style.titleStyle.align,
        fontSize: style.titleStyle.fontSize + 'px',
        color: style.titleStyle.color,}">
        {{ (activatedLabel ? activatedLabel+ ' ': '') + config.chartTitle }}
        <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
          <div slot="content" v-html="indicatorDescription"></div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
    </div>
    <div ref="line" class="line-chart-container"></div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as echarts from 'echarts'
// import { getNumberFormat } from '@/utils/common'
import { COLOR_LIST } from '@/utils/defaultColorData'
import { imgURLtoBase64 } from '@/utils/common'
import { relateBus } from '@/eventBus'
import { lineBaseOption } from './options'
import ChartMixin from './mixin'

export default {
  mixins: [ChartMixin],

  data () {
    return {
      activatedLabel: (this.config.chartSet.chartStyle.isLinkMap && this.config.chartViewData.chartData[0]?.labelName) || '',
    }
  },
  computed: {
    isMultipleChartData () {
      const data = this.currentComponent?.chartViewData?.chartData
      const currentChartData = data?.setAxis ? data.realChartData : data
      return !!currentChartData?.[0]?.labelName
    },
    dataIndex () {
      if (this.isMultipleChartData && this.style.chartStyle.isLinkMap) {
        const i = this.config.chartViewData.chartData.findIndex(bar => bar.labelName === this.activatedLabel)
        return i === -1 ? 0 : i
      } else {
        return 0
      }
    },
    // 表格数据
    chartData () {
      if (this.isMultipleChartData && this.style.chartStyle.isLinkMap) {
        return this.config.chartViewData.chartData[this.dataIndex].realChartData
      } else {
        // 通过 setAxis 判断当前是否为多轴
        return this.config.chartViewData.chartData?.setAxis ? this.config.chartViewData.chartData.realChartData : this.config.chartViewData.chartData
      }
    },
    setAxis () {
      if (this.isMultipleChartData && this.style.chartStyle.isLinkMap) {
        return this.config.chartViewData.chartData[this.dataIndex].setAxis
      }
      return this.config.chartViewData.chartData?.setAxis
    },
    style () {
      return this.config.chartSet
    },
    // 维度
    dataAxis () {
      const list = []
      if (this.chartData?.length && Array.isArray(this.chartData)) {
        const colKeyList = Object.keys(this.chartData[0])
        this.chartData.slice(1).forEach(bar => {
          list.push(bar[colKeyList[0]]) // 第一列数据(维度)
        })
        return list
      } else {
        return []
      }
    },
    // 数据
    series () {
      const list = []
      let initItem = {
        name: '',
        type: 'line',
        smooth: this.style.chartStyle.smooth,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          width: 2,
        },
        data: [],
      }
      if (this.config.chartComponent === 'areaLine') {
        initItem = {
          ...initItem,
          areaStyle: {
            opacity: 0.5,
          },
        }
      }
      //  双轴设置，yAxisIndex 设置数据对应的坐标轴，默认为0
      const doubleAxis = {
        ...initItem,
        yAxisIndex: 1,
        itemStyle: {
          normal: {
            lineStyle: {
              type: 'dotted',
            },
          },

        },
      }
      if (!this.chartData?.length) {
        return
      }
      // 除第一列(维度)之外的所有表头key集合 keyList
      const colKeyList = Object.keys(this.chartData[0]).slice(1)
      // 表头
      const tableHeader = this.chartData[0]
      // 表格数据 (去除第一行(表头))
      const tableData = this.chartData.slice(1)
      // 遍历除第一列(维度)之外的所有列
      colKeyList.forEach((key, index) => {
        // 排除空数据
        if (!tableData.every(row => (row[key] === '' || row[key] === undefined))) {
          const itemIndex = this.style.chartStyle?.doubleAxis && this.setAxis ? this.setAxis[key] : 0
          list.push({
            ...itemIndex ? doubleAxis : initItem,
            name: tableHeader[key], // 当前数据列的表头
            data: tableData.map(bar => bar[key]), // 当前数据列
          })
        }
      })

      return list
    },

  },

  watch: {
    isMultipleChartData (val) {
      if (!val) {
        this.activatedLabel = ''
      }
    },

    // 全局样式监听
    'globalConfig.chartColors': {
      handler () {
        // 主题颜色修改
        this.option.color = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value
        this.charts.setOption(this.option, true)
      },
      deep: true,
    },
    // 配置项变更
    config: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
    async borderStyle (val) {
      if (val) {
        this.borderImgUrl = await imgURLtoBase64(val)
      } else {
        this.borderImgUrl = ''
      }
    },
  },

  async created () {
    if (this.borderStyle) {
      this.borderImgUrl = await imgURLtoBase64(this.borderStyle)
    }
    if (!this.style.chartStyle?.carouselDelay) { this.$set(this.config.chartSet.chartStyle, 'carouselDelay', 3) }
    // if (!this.style.chartStyle?.isLegend) { this.$set(this.config.chartSet.chartStyle, 'isLegend', false) }
    if (!this.style.chartStyle?.legendSize) { this.$set(this.config.chartSet.chartStyle, 'legendSize', 12) }
  },
  mounted () {
    if (!this.charts) {
      this.charts = echarts.init(this.$refs.line)
    }
    this.init()
    relateBus.$on('activeChange', (mapAddSn, data) => {
      if (this.style.chartStyle.isLinkMap && data.name && this.config.chartSet.chartStyle.linkMap === mapAddSn) {
        this.activatedLabel = data.name
        this.init()
      }
    })
  },
  methods: {
    init () {
      this.option = _.merge(_.cloneDeep(lineBaseOption), {
        grid: {
          top: this.style.chartStyle.isLegend ? '46px' : '30px',
        },
        tooltip: {
          textStyle: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        color: COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value,
        xAxis: {
          // 填充数据
          data: this.dataAxis,
          axisLabel: {
            fontSize: this.style.chartStyle.fontSize,
          },
        },
        legend: {
          show: this.style.chartStyle.isLegend,
          textStyle: {
            fontSize: this.style.chartStyle.legendSize,
          },
        },
        yAxis: [
          {
            axisLabel: {
              fontSize: this.style.chartStyle.fontSize,
            },
          },
          {
            axisLabel: {
              fontSize: this.style.chartStyle.fontSize,
            },
          },
        ],
        label: {
          show: this.style.chartStyle.isLabel,
          fontSize: this.style.chartStyle.fontSize,
        },
        series: this.series,
      })

      this.charts.setOption(this.option, true)

      // 是否轮播 tooltips
      if (this.style.chartStyle.carousel && this.series?.length > 0) {
        this.tooltipsActive()
        this.mouseEvents()
      } else {
        this.charts.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.index,
        })
        if (this.timer) {
          clearInterval(this.timer)
          this.index = -1
        }
      }
      // resize
      this.$nextTick(() => {
        this.charts.resize()
      })
    },

  },
}
</script>

<style lang='scss' scoped>
.line-chart{
  display: flex;
  flex-direction: column;
  &-wrapper {
    position: relative;
    width:100%;
  }
  &-border {
    position: absolute;
    top: 0;
    height: 100%;
    z-index: -1;

  }
  &-title {
    padding:7px 30px;
  }
  .line-chart-container{
    flex: 1;
  }
}
</style>
